import React from 'react';
import Icon from '../../../components/AppIcon';
import AppImage from '../../../components/AppImage';

const WhiteboardDisplay = ({ currentLesson, isPlaying }) => {
  return (
    <div className="bg-card rounded-lg border border-border overflow-hidden shadow-elevation-2">
      {/* Whiteboard Header */}
      <div className="bg-primary text-primary-foreground px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Icon name="Presentation" size={20} />
          <h3 className="font-semibold text-base">Interactive Whiteboard</h3>
        </div>
        <div className="flex items-center gap-2">
          {isPlaying && (
            <div className="flex items-center gap-1.5 text-sm">
              <div className="w-2 h-2 bg-error rounded-full animate-pulse" />
              <span>Live</span>
            </div>
          )}
        </div>
      </div>

      {/* Whiteboard Content */}
      <div className="bg-white p-6 min-h-[500px] lg:min-h-[600px] flex flex-col">
        {/* BABOK Framework Image */}
        <div className="flex-1 flex items-center justify-center mb-4">
          <div className="w-full max-w-full">
            <AppImage
              src="/assets/images/OnePageView_of_the_BABOK_KAs-1770284887196.png"
              alt="Complete BABOK Knowledge Areas Framework - One Page Overview showing all six knowledge areas: Business Analysis Planning and Monitoring, Elicitation and Collaboration, Requirements Life Cycle Management, Strategy Analysis, Requirements Analysis and Design Definition, and Solution Evaluation"
              className="w-full h-auto rounded-lg shadow-elevation-1"
            />
          </div>
        </div>

        {/* Current Focus Indicator */}
        <div className="bg-accent/10 border border-accent/30 rounded-lg p-4">
          <div className="flex items-start gap-3">
            <div className="flex-shrink-0 mt-0.5">
              <Icon name="Target" size={20} className="text-accent" />
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="font-semibold text-foreground mb-1">
                Current Focus: {currentLesson?.knowledgeArea}
              </h4>
              <p className="text-sm text-muted-foreground">
                {currentLesson?.title}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Classroom Footer */}
      <div className="bg-muted px-4 py-2 flex items-center justify-between text-xs text-muted-foreground">
        <div className="flex items-center gap-2">
          <Icon name="GraduationCap" size={14} />
          <span>Professional Classroom Setting</span>
        </div>
        <div className="flex items-center gap-2">
          <Icon name="Clock" size={14} />
          <span>Duration: {currentLesson?.duration}</span>
        </div>
      </div>
    </div>
  );
};

export default WhiteboardDisplay;